import { ComponentFactoryResolver, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { TaxNewsWidgetComponent } from './tax-news-widget/tax-news-widget.component';
import { LawChangesWidgetComponent } from './law-changes-widget/law-changes-widget.component';
import { DashboardContentComponent } from './dashboard-content/dashboard-content.component';
import { DashboardFilterComponent } from './dashboard-filter/dashboard-filter.component';
import { DueDatesWidgetComponent } from './due-dates-widget/due-dates-widget.component';
import { dashboardRoutes } from './dashboard.routes';
import { RouterModule } from '@angular/router';
import { DashboardDynamicComponentHelper } from './dashboard-dynamic-component-helper';
import { TaxnewsIncorporationTooltipFormatPipe } from './pipes/taxnews-incorporation-tooltip-format.pipe';
import { TaxnewsDateFormatPipe } from './pipes/taxnews-date-format.pipe';
import { DateCellViewerComponent } from './cell-components/date-cell-viewer/date-cell-viewer.component';
import { EventCellViewerComponent } from './cell-components/event-cell-viewer/event-cell-viewer.component';
import { ManageCellViewerComponent } from './cell-components/manage-cell-viewer/manage-cell-viewer.component';
import { Store, StoreModule } from '@ngrx/store';
import { dashboardReducer } from './store/reducer/dashboard-reducer';
import { DashboardHitmapComponent } from './dashboard-hitmap/dashboard-hitmap.component';
import { EffectsModule } from '@ngrx/effects';
import { DashbordEffects } from './store/effect/dashboard-effects';
import { AnalyticsEntryDialogueComponent } from './analytics-entry-dialogue/analytics-entry-dialogue.component';
import { DashboardFilterToolbarComponent } from './dashboard-filter-toolbar/dashboard-filter-toolbar.component';
import { ItcdAnalyticsComponent } from './itcd-analytics/itcd-analytics.component';
import { PbiPlaygroundComponent } from './pbi-playground/pbi-playground.component';
import { BrowserModule } from "@angular/platform-browser";
import { PowerSearchBarComponent } from './power-search-bar/power-search-bar.component';
import { TaxNewsComponent } from './tax-news/tax-news.component';
import { powerSearchReducer } from "./store/reducer/power-search.reducer";
import { VisualizerNotificationService } from "./Services/visualizer-notification.service";
import { AnalyticsV2Component } from './analytics-v2/analytics-v2.component';
import { Dac6AnalyticsV2Component } from './dac6-analytics-v2/dac6-analytics-v2.component';
import { PowerSearchDashboardV2Component } from './power-search-dashboard-v2/power-search-dashboard-v2.component';
import { PowerSearchContentv2Component } from './power-search-contentv2/power-search-contentv2.component';
import { OicAnalyticsComponent } from './oic-analytics/oic-analytics.component';
import { FormsDownloadComponent } from '@features/dashboard/forms-download/forms-download.component';
import { ProjectsModule } from '@features/projects/projects.module';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import { getAccessToken } from '@shared/store/selectors/security.selector';
import { PlatformCommand } from '@shared/commands/command-base';
import { CommandService } from '@core/services/command.service';
import { HomePageCountryDialogComponent } from './home-page-country-dialog/home-page-country-dialog.component';
import { RootDynamicComponentHelper } from "@shared/helpers/root-dynamic-component-helper";
import { PlatformWorkflowInfoComponent } from '@shared/components/platform-workflow-info/platform-workflow-info.component';
import { Api } from '@shared/constants/common-field.constants';
import { DashboardHomeCardsComponent } from './dashboard-home-cards/dashboard-home-cards.component';
import { ProfileTimeZoneBannerComponent } from './components/profile-time-zone-banner/profile-time-zone-banner.component';

@NgModule({
  declarations: [
    PlatformWorkflowInfoComponent,
    PbiPlaygroundComponent,
    AnalyticsEntryDialogueComponent,
    DashboardHitmapComponent,
    DueDatesWidgetComponent,
    DashboardFilterComponent,
    DashboardContentComponent,
    LawChangesWidgetComponent,
    TaxNewsWidgetComponent,
    TaxnewsIncorporationTooltipFormatPipe,
    TaxnewsDateFormatPipe,
    DateCellViewerComponent,
    EventCellViewerComponent,
    ManageCellViewerComponent,
    DashboardFilterToolbarComponent,
    ItcdAnalyticsComponent,
    PbiPlaygroundComponent,
    PowerSearchBarComponent,
    TaxNewsComponent,
    AnalyticsV2Component,
    Dac6AnalyticsV2Component,
    PowerSearchDashboardV2Component,
    PowerSearchContentv2Component,
    OicAnalyticsComponent,
    FormsDownloadComponent,
    HomePageCountryDialogComponent,
    DashboardHomeCardsComponent,
    ProfileTimeZoneBannerComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(dashboardRoutes),
    StoreModule.forFeature('dashboard-store', dashboardReducer),
    StoreModule.forFeature('power-search', powerSearchReducer),
    EffectsModule.forFeature([DashbordEffects]),
    ProjectsModule
  ],
  exports: [
    DashboardHitmapComponent,
    DashboardFilterComponent,
    DashboardContentComponent,
    DueDatesWidgetComponent,
    TaxNewsWidgetComponent,
    LawChangesWidgetComponent,
    ItcdAnalyticsComponent,
    HomePageCountryDialogComponent,
    DashboardHomeCardsComponent
  ],
  providers: [VisualizerNotificationService]
})
export class DashboardModule {
  constructor(private securityStateStore: Store<SecurityState>, private commandService: CommandService, private componentFactoryResolver: ComponentFactoryResolver) {
    DashboardDynamicComponentHelper.init();
    RootDynamicComponentHelper.registerComponentFactoryResolver(this.componentFactoryResolver);
    // this.securityStateStore.select(getAccessToken).subscribe(accessToken => {
    //   if (!accessToken.expires_in) {
    //     accessToken.expires_in = 0;
    //   }
    //   const command = new PlatformCommand('EntityDesignerProLinkCommand', 'EntityChartApi');
    //   command.fieldValues['RefreshToken'] = accessToken.refresh_token;
    //   command.fieldValues['ExpiryDate'] = new Date(0, 0, 0, 0, 0, accessToken.expires_in);
    //   this.commandService.registrPlatformLinkCommand('/itp-desktop', command);
    // });
    let command = new PlatformCommand('HomePageCommand', Api.Security);
    this.commandService.registrPlatformLinkCommand('/', command);
    this.commandService.registrPlatformLinkCommand('/home', command);
  }
}
